import React from 'react';
import { FormRenderProps } from 'react-final-form';

import PageBaseProps from 'types/PageBase';
import FormKeys from 'modules/form/types/FormKeys';
import { QuestionsForm as QuestionsFormType } from 'types/QuestionsForm';

import { UPDATE_FIXED_CACHE_KEY } from 'modules/selfServices/constants';

import { useUpdateSelfServiceMutation } from 'modules/selfServices/service';

import PageFooter from 'components/ui/PageFooter';

import Questions from './Questions';

type QuestionsFormRenderProps = FormRenderProps<QuestionsFormType>
  & Pick<PageBaseProps, 'onPrev' | 'shouldDisplayBackButton' | 'isPenultimate'>;

const QuestionsFormRender: React.FC<QuestionsFormRenderProps> = ({
  onPrev,
  handleSubmit,
  isPenultimate,
  hasValidationErrors,
  shouldDisplayBackButton,
}) => {
  const [, { isLoading: isUpdateLoading }] = useUpdateSelfServiceMutation({ fixedCacheKey: UPDATE_FIXED_CACHE_KEY });

  return (
    <>
      <main className="main-content max-w-content">
        <div className="content">
          <Questions name={FormKeys.QUESTIONS} />
        </div>
      </main>
      <PageFooter
        onPrev={onPrev}
        onNext={handleSubmit}
        loading={isUpdateLoading}
        isPenultimate={isPenultimate}
        disabledStyle={hasValidationErrors}
        shouldDisplayBackButton={shouldDisplayBackButton}
      />
    </>
  );
};

export default QuestionsFormRender;
